import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'build-section',
  templateUrl: './build-section.component.html',
  styleUrls: ['./build-section.component.scss']
})
export class BuildSectionComponent {
  @Input() disabled: boolean;
  @Input() active: boolean;
  @Input() title: string;
  @Input() contentOnly: boolean;
  @Input() contentExtraClass = '';
}
